import { withTranslation } from './withTranslation';
import { Translator } from './Translator';

export { Translator };
export default withTranslation;
